<div class="separated-container">
  <div class="content">
    @if (state$ | async | lowercase; as activeStep) {
      <div class="container text-style">
        @if (isSupportingDocumentsState) {
          <fol-decision [decision]="decision()" [steps]="steps" [validatedSteps]="validatedSteps" />
        }

        @if (!isSupportingDocumentsState) {
          @if (activeStep === 'application') {
            <div class="row center text-center space-top-2">
              <span class="quit reminder">{{ 'stepper.application.text' | translate }}</span>
            </div>
          }
          <div class="title-container row center space-top-2" [ngClass]="{ signature: isSignatureState }">
            <!-- title block -->
            @if (!isSignatureState) {
              <h1>
                {{ 'stepper.' + activeStep + '.title' | translate }}
              </h1>
            }
            <!-- title block -->
          </div>
          <div class="space-top-4">
            <div class="margin-4" [ngClass]="{ reverse: isFinalState }">
              @if (!(isCreditModerne && isApplicationState)) {
                <div class="display-flex">
                  <p>
                    {{ 'stepper.' + activeStep + '.subtitle' | translate }}
                  </p>
                </div>
              }
              <div class="column center step-wrapper space-top-1 gap-1">
                @for (step of steps; track step; let i = $index) {
                  <fol-step
                    [num]="i + 1"
                    [title]="'stepper.steps.' + step.toLowerCase() | translate"
                    [validated]="validatedSteps.includes(step)"
                    [active]="step.toLowerCase() === activeStep" />
                }
              </div>
            </div>
          </div>
          @if (isApplicationState) {
            <div class="justify-sticky-buttons-center, sticky-wrapper">
              <a mat-flat-button color="primary" [routerLink]="['../mobi-sub']" class="do-not-display-as-a-link">{{
                'stepper.buttons.' + activeStep | translate
              }}</a>
            </div>
          }
        }
      </div>
    }
  </div>
</div>
